import React from "react";
import { Box, CircularProgress, Backdrop } from "@material-ui/core";

const CustomOverlay = ({ overlay }) => {
  return (
    <Backdrop open={overlay} style={{ zIndex: 1201 }}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="100%"
      >
        {/* 色をsecondaryに修正 */}
        <CircularProgress color="secondary" />
      </Box>
    </Backdrop>
  );
};

export default CustomOverlay;